import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { auth } from "../api";
import { signInWithGoogle as firebaseGoogleSignIn } from "../firebase";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (auth.isLoggedIn()) {
      auth.me().then(setUser).catch(() => setUser(null)).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (username, password) => {
    const user = await auth.login(username, password);
    setUser(user);
    return user;
  }, []);

  const register = useCallback(async (username, phone, password) => {
    const user = await auth.register(username, phone, password);
    setUser(user);
    return user;
  }, []);

  const googleLogin = useCallback(async () => {
    const { token: firebaseToken } = await firebaseGoogleSignIn();
    const data = await auth.googleLogin(firebaseToken);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await auth.logout();
    } catch (e) {
      // ignore
    }
    setUser(null);
  }, []);

  const value = { user, loading, login, register, googleLogin, logout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
